@if (entry?.base?.display) {
  <div>
    <app-doctor-information
      [defaultRadius]="entry.custom?.defaultRadius ? entry.custom.defaultRadius : null"
      [primaryCareProviderOnly]="entry.custom?.isPcp"
      [market]="market"
      (doctorsChanged)="doctorsChanged($event)">
    </app-doctor-information>
  </div>
}